const refreshTodoSidePanel = (todoId) => {
  const todoCard = document.querySelector(`[data-todo-id='${todoId}']`);

  document.dispatchEvent(new CustomEvent("sidePanel:open", { detail: { url: todoCard.dataset.url } }));
};

export { refreshTodoSidePanel };
